import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { GameState } from "./GameState";

export class StartLayer extends Phaser.Group {

    private blurredStage: Phaser.Image;
    private startLabel: Phaser.BitmapText;
    
    constructor(game: Phaser.Game) {

        super(game, null, "start-layer");
        
        this.blurredStage = new Phaser.Image(this.game, 0, 0, "blurred-stage", null);
        this.blurredStage.width = GameConstants.GAME_WIDTH;
        this.blurredStage.height = GameConstants.GAME_HEIGHT;
        this.add(this.blurredStage);

        this.startLabel = new Phaser.BitmapText(this.game, - GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "beacon", "Welcome home!", 136);
        this.startLabel.anchor.setTo(.5, .5);
        this.startLabel.scale.x = GameVars.scaleX;
        this.add(this.startLabel); 
    }
    
    public animate(): void {
        
        this.game.add.tween(this.startLabel)
        .to({x: GameConstants.GAME_WIDTH / 2 }, 600 , Phaser.Easing.Cubic.Out, true, 450)
        .onComplete.add(function(): void {
                this.game.add.tween(this.blurredStage)
                    .to({alpha: 0 }, 1200 , Phaser.Easing.Cubic.Out, true, 1400);
                this.game.add.tween(this.startLabel)
                    .to({x: 3 * GameConstants.GAME_WIDTH / 2 }, 1200 , Phaser.Easing.Cubic.Out, true, 1400)
                    .onComplete.add(function(): void {
                        this.startGame();
                    }, this);
        }, this);
    }
    
    private startGame(): void {
        
        this.game.time.events.add(800, function(): void{
                GameState.currentInstance.startGame();
        }, this);  
    }
}
